import {ReactNode} from "react";
import {
    RenderableDocument,
    DibJsonNode,
    ElementDataAccounting,
    RenderNodeOptions,
} from "../../types";
import {AccountingTable} from "./AccountingTable";

const test = (node: DibJsonNode, options: RenderNodeOptions) => {
    if (options?.skipAugmentations) return false;
    const elementData = node.elementData as ElementDataAccounting | null;
    return !!elementData?.accounting || !!elementData?.tax;
};

const processor = (
    node: DibJsonNode,
    topicData: RenderableDocument,
    renderedChildren: ReactNode[]
) => {
    const accountingTableComponent = (
        <AccountingTable
            augmentation="AccountingTable"
            key={`${node.element?.attributes?.id}-accountingtable`}
            node={node}
            topicData={topicData}
        />
    );

    if (renderedChildren.length === 0) {
        return [accountingTableComponent];
    }

    return [
        renderedChildren[0],
        accountingTableComponent,
        ...renderedChildren.slice(1),
    ];
};

export const accountingTable = {test, processor};
